export default __webpack_public_path__ + "static/media/banner-3.0ff21fcd.jpg";